const socketMiddleware = (socket) => (store) => (next) => (action) => {
  if (action.isSocket) {
    const { branchId, restaurantId, id } = store.getState().user;
    const channels = [id, branchId];

    if (Boolean(id)) {
      if (socket.connected === false) {
        socket.on("connect", async () => {
          channels.forEach((channel) => {
            socket.emit("JOIN_ROOM", channel);
          });
          socket.emit("GET_ORDERS", {
            branchId,
            restaurantId,
            userId: id,
          });
          socket.emit(action.type, {
            branchId,
            restaurantId,
            userId: id,
            ...action.payload,
          });
        });
      } else {
        if (socket.connected) {
          channels.forEach((channel) => {
            socket.emit("JOIN_ROOM", channel);
          });
          socket.emit(action.type, {
            branchId,
            restaurantId,
            userId: id,
            ...action.payload,
          });
        }
      }
    } else {
      next(action);
    }
  } else {
    next(action);
  }
};
export default socketMiddleware;
